import { CONSTANTS } from 'config/constants';
import { InvoiceSettings, LabClient } from 'models/client-directory';
import { Invoicing } from 'models/common';
import { ClientDirInvoiceEmailSettingsFormData } from 'models/forms';
import { Organization } from 'models/organization';
import { customerSettings } from 'utils/customerSettings';

const getRecipientEmail = (
    invoiceSettings: InvoiceSettings,
    invoicing: Invoicing,
    labOverrideClinicForcedSetting: boolean,
) => {
    if (labOverrideClinicForcedSetting) {
        return invoiceSettings?.emailSettings?.to || [];
    }
    if (invoicing?.communication?.email) {
        return [invoicing?.communication?.email];
    }
    return invoiceSettings?.emailSettings?.to || [];
};

export const emptyInvoiceEmailSettingsData = (labClient?: LabClient, currentOrg?: Organization) => {
    const labOverrideClinicForcedSetting = customerSettings.getCustomerSetting(
        currentOrg?.customerSettings || [],
        CONSTANTS.SETTINGS_NAMES.ALLOW_LAB_INVOICE_OVERRIDE,
    );
    return {
        replyAddress:
            labClient?.invoiceSettings?.emailSettings?.replyAddress ||
            currentOrg?.invoicing?.communication?.email ||
            '',
        to: getRecipientEmail(
            labClient?.invoiceSettings || ({} as InvoiceSettings),
            labClient?.customer?.invoicing || ({} as Invoicing),
            labOverrideClinicForcedSetting,
        ),
        cc: labClient?.invoiceSettings?.emailSettings?.cc || [],
        bcc: labClient?.invoiceSettings?.emailSettings?.bcc || [],
        subject: (labClient?.invoiceSettings?.emailSettings?.subject as string) || '',
        body:
            (labClient?.invoiceSettings?.emailSettings?.body as string) ||
            'Hej,\n\nVänligen se bifogad faktura för beställning av tandteknik.',
        creditSubject: (labClient?.invoiceSettings?.emailSettings?.creditSubject as string) || '',
        creditBody:
            (labClient?.invoiceSettings?.emailSettings?.creditBody as string) ||
            'Hej,\n\nVänligen se bifogad kreditfaktura.',
    } as ClientDirInvoiceEmailSettingsFormData;
};
